import { render, staticRenderFns } from "./startPage.vue?vue&type=template&id=3b448a66&scoped=true&"
import script from "./startPage.vue?vue&type=script&lang=ts&"
export * from "./startPage.vue?vue&type=script&lang=ts&"
import style0 from "./startPage.vue?vue&type=style&index=0&id=3b448a66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b448a66",
  null
  
)

export default component.exports